/**
 * 报价配置
 */
import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import {
  Button,
  Card,
  Cascader,
  Collapse,
  Form,
  Input,
  Select,
  Table,
  message,
} from "antd";
import {
  offerPremiumListRequest,
  offerPremiumAdd,
  offerPremiumDelete,
  areaInsuranceListRequest,
} from "@/service/offerManage";
import { carTypeListRequest } from "@/service/offerRecord";
import styles from "./index.module.scss";
import { PlusOutlined } from "@ant-design/icons";
import LoadingWrapper from "@/components/loadingWrapper";

const { Panel } = Collapse;
const offerManage = () => {
  const [allData, setAllData] = useState<any>(); //所有报价配置数据
  const [activeKey, setActiveKey] = useState<any>(["column"]); // 展开的面板
  const [area, setArea] = useState([]); // 区域
  const [itemColumnsValue, setItemColumnsValue] = useState<any>([]); //初始保司评价数据
  const [scoreColumnsValue, setScoreColumnsValue] = useState<any>([]); //初始商业分析数据
  const [riskColumnsValue, setRiskColumnsValue] = useState<any>([]); //初始出险次数数据
  const [deviceColumnsValue, setDeviceColumnsValue] = useState<any>([]); //初始出险次数数据
  const [taxColumnsValue, setTaxColumnsValue] = useState<any>([]); //初始基础税费数据
  const [newenergyColumnsValue, setNewenergyColumnsValue] = useState<any>([]); //初始新能源车分期支付配置数据
  const [unnewenergyColumnsValue, setUnnewenergyColumnsValue] = useState<any>( []); //初始中富评级评分配置数据
  const [scoreGradeColumnsValue, setScoreGradeColumnsValue] = useState<any>( []); //初始非新能源车分期支付配置数据
  const [vehicletypeColumnsValue, setVehicletypeColumnsValue] = useState<any>( []); //初始车型配置
  const [brandColumnsValue, setBrandColumnsValue] = useState<any>( []); //初始品牌配置
  const [loading, setLoading] = useState<boolean>(false); // 运维组数据的loading
  const [grades, setGrades] = useState<any>(); // 保司
  const [gradesFactors, setGradesFactors] = useState<any>(); // 折算系数
  const [scores, setScores] = useState<any>(); // 商业分析
  const [scoresFactor, setScoresFactors] = useState<any>(); // 商业分析折算系数
  const [riskFactors, setRiskFactors] = useState<any>(); // NCD系数折算系数
  const [deviceFactors, setDeviceFactors] = useState<any>(); // 设备保费配置保费
  const [deviceAreas, setDeviceAreas] = useState<any>(); // 设备保费配置区域
  const [taxFactors, setTaxFactors] = useState<any>(); // 基础税费配置保费
  const [taxAreas, setTaxAreas] = useState<any>(); // 基础税费配置区域
  const [newenergyItem, setNewenergyItem] = useState<any>(); // 新能源车分期支付配置指标
  const [newenergyFactors, setNewenergyFactors] = useState<any>(); // 新能源车分期支付配置折算系数
  const [newenergyAreas, setNewenergyAreas] = useState<any>(); // 新能源车分期支付配置配置区域
  const [unNewenergyItem, setUnNewenergyItem] = useState<any>(); // 非新能源车分期支付配置指标
  const [unNewenergyFactors, setUnNewenergyFactors] = useState<any>(); // 非新能源车分期支付配置折算系数
  const [unNewenergyAreas, setUnNewenergyAreas] = useState<any>(); // 非新能源车分期支付配置配置区域
  const [vehicletypeFactors, setVehicletypeFactors] = useState<any>(); // 非新能源车不分期支付配置折算系数(机动车)
  const [vehicletypeFactorsOne, setVehicletypeFactorsOne] = useState<any>(); // 非新能源车分期支付配置折算系数(机动车)
  const [vehicletypeFactorsTwo, setVehicletypeFactorsTwo] = useState<any>(); // 非新能源车分期支付配置折算系数(特征车)
  const [vehicletypeFactorsThree, setVehicletypeFactorsThree] = useState<any>(); // 非新能源车不分期支付配置折算系数(特征车)
  const [vehicletypeFactorsFour, setVehicletypeFactorsFour] = useState<any>(); // 非新能源车分期支付配置折算系数(新能源车)
  const [vehicletypeFactorsFive, setVehicletypeFactorsFive] = useState<any>(); // 非新能源车不分期支付配置折算系数(新能源车)
  const [vehicletypeFactorsSix, setVehicletypeFactorsSix] = useState<any>(); //
  const [vehicletypeFactorsSeven, setVehicletypeFactorsSeven] = useState<any>(); //
  const [vehicletypeAreas, setVehicletypeAreas] = useState<any>(); // 非新能源车分期支付配置配置区域
  const [vehicleTypeActiveKey, setVehicleTypeActiveKey] = useState<any[]>([]);
  const [brandActiveKey, setBrandActiveKey] = useState<any[]>([]);
  const [scoreGradeItem, setScoreGradeItem] = useState<any>(); // 中富评分评级  指标配置
  const [scoreGradeFactorsOne, setScoreGradeFactorsOne] = useState<any>(); // 中富评分评级 系数配置
  const [scoreGradeFactorsTwo, setScoreGradeFactorsTwo] = useState<any>(); // 中富评分评级 平均值配置
  const [scoreGradeFactorsThree, setScoreGradeFactorsThree] = useState<any>(); // 中富评分评级 方差配置
  const [risks, setRisks] = useState('')
  const [vehicleType, setVehicleType] = useState<any>([]); // 车辆类型

  const [form] = Form.useForm();
  useEffect(() => {
    getOfferPremium();
    getareaData();
    getVehicleType();
  }, []);

  // 获取区域数据
  const getareaData = async () => {
    const tree: any = [];
    const areaData = await areaInsuranceListRequest();
    const area = areaData.data.data;
    for (let i = 0; i < area.length; i++) {
      const item = area[i];
      if (item.parentCode === null) {
        tree.push({ ...item, children: [] });
      } else {
        const parent = tree.find((node: any) => node.code === item.parentCode);
        if (parent) {
          parent.children.push({ ...item });
        }
      }
      if (i === area.length - 1) {
        setArea(tree);
      }
    }
  };

  // 获取车辆类型
  const getVehicleType = async () => {
    const res = await carTypeListRequest();
    const data = res.data?.data || [];
    const options = data
      .filter((item: any) => item.parentCode !== null)
      .map((item: any) => ({ label: item.name, value: item.name }));
    setVehicleType(options);
  };
  // 获取报价配置
  const getOfferPremium = async () => {
    setLoading(true);
    //车型配置先为空
    // setVehicletypeColumnsValue([]);
    try {
      const res = await offerPremiumListRequest();
      const resData = res.data?.data || {};
      setAllData(resData);
      //循环遍历resData
      const result = {};
      let GRADEData: any = []; //保司评级
      let SCOREData: any = []; //保司评分
      let RISKData: any = []; //出险次数
      let DEVICEData: any = []; //设备保费
      let TAXData: any = []; //基础税费
      let NEWENERGYEData: any = []; //新能源车分期支付
      let UNNEWENERGYData: any = []; //非新能源车分期支付
      let VEHICLETYPEData: any = []; //车型配置
      let BRANDData: any = []; //品牌配置
      let SELFPARAMESData: any = []; //中富评级评分配置
      resData.map((item: any, index: any) => {
        if (item.type === "GRADE") {
          GRADEData.push(item);
        } else if (item.type === "SCORE") {
          SCOREData.push(item);
        } else if (item.type === "RISK" ) {
          if(!item.item) {
            RISKData.unshift(item)
          } else {
            RISKData.push(item);
          }
          
        } else if (item.type === "DEVICE") {
          DEVICEData.push(item);
        } else if (item.type === "TAX") {
          TAXData.push(item);
        } else if (item.type === "NEWENERGY") {
          NEWENERGYEData.push(item);
        } else if (item.type === "UNNEWENERGY") {
          UNNEWENERGYData.push(item);
        } else if (item.type === "VEHICLETYPE") {
          VEHICLETYPEData.push(item);
        } else if (item.type === "BRAND") {
          BRANDData.push(item);
        }else if (item.type === "SELFPARAMES") {
          SELFPARAMESData.push(item);
        }

        if (index == resData.length - 1) {
          setItemColumnsValue(GRADEData);
          setScoreColumnsValue(SCOREData);
          setRiskColumnsValue(RISKData);
          setDeviceColumnsValue(DEVICEData);
          setTaxColumnsValue(TAXData);
          setNewenergyColumnsValue(NEWENERGYEData);
          setUnnewenergyColumnsValue(UNNEWENERGYData);
          setScoreGradeColumnsValue(SELFPARAMESData);
          //将数据按照车型分单独数组
          const aa = VEHICLETYPEData.reduce((acc: any, cur: any) => {
            const key = cur.item;
            if (!acc[key]) {
              acc[key] = [];
            }
            if (cur.area) {
              acc[key].push(cur);
            } else {
              acc[key].unshift(cur)
            }
            
            return acc;
          }, {});
          if (Object.values(aa).length > 0) {
            setVehicletypeColumnsValue(Object.values(aa));
          }
          const brandData = BRANDData.reduce((acc: any, cur: any) => {
            const key = cur.item || "";
            if (!acc[key]) {
              acc[key] = [];
            }
            if (cur.subItem1) {
              acc[key].push(cur);
            } else {
              acc[key].unshift(cur);
            }

            return acc;
          }, {});
          setBrandColumnsValue(Object.values(brandData));
        }
      });
      setLoading(false);
    } catch (error) {}
  };

  //删除数据
  const deleteDataColumns = async (id: any) => {
    if (id) {
      const res = await offerPremiumDelete(id);
      if (res.data?.code === 0) {
        message.success("删除成功");
        getOfferPremium();
      }
    } else {
      //刷新页面
      getOfferPremium();
    }
  };

  //编辑折算系数
  const changeFactor = (e: any, key: any) => {
    if (key == "grade") {
      setGradesFactors(e);
    } else if (key == "score") {
      setScoresFactors(e);
    } else if (key == "risk") {
      setRiskFactors(e);
    } else if (key == "device") {
      setDeviceFactors(e);
    } else if (key == "tax") {
      setTaxFactors(e);
    } else if (key == "newenergy") {
      setNewenergyFactors(e);
    } else if (key == "unnewenergy") {
      setUnNewenergyFactors(e);
    } else if (key == "vehicletype") {
      setVehicletypeFactors(e);
    } else if (key == "vehicletypeOne") {
      setVehicletypeFactorsOne(e);
    } else if (key == "vehicletypeTwo") {
      setVehicletypeFactorsTwo(e);
    } else if (key == "vehicletypeThree") {
      setVehicletypeFactorsThree(e);
    } else if (key == "vehicletypeFour") {
      setVehicletypeFactorsFour(e);
    } else if (key == "vehicletypeFive") {
      setVehicletypeFactorsFive(e);
    } else if (key == "vehicletypeSix") {
      setVehicletypeFactorsSix(e);
    } else if (key == "vehicletypeSeven") {
      setVehicletypeFactorsSeven(e);
    }else if (key == "scoreGradeOne") {
      setScoreGradeFactorsOne(e);
    } else if (key == "scoreGradeTwo") {
      setScoreGradeFactorsTwo(e);
    } else if (key == "scoreGradeThree") {
      setScoreGradeFactorsThree(e);
    }
    };
  //编辑区域
  const changeAreas = (e: any, key: any) => {
    if (key == "device") {
      const a = e;
      const b = a.join(",");
      setDeviceAreas(b);
    } else if (key == "tax") {
      const a = e;
      const b = a.join(",");
      setTaxAreas(b);
    } else if (key == "newenergy") {
      const a = e;
      const b = a.join(",");
      setNewenergyAreas(b);
    } else if (key == "unnewenergy") {
      const a = e;
      const b = a.join(",");
      setUnNewenergyAreas(b);
    } else if (key == "vehicletype") {
      const a = e;
      const b = a.join(",");
      setVehicletypeAreas(b);
    }
  };
  //保存按钮
  const saveData = async (item: any, key: any) => {
    if (key == "grade") {
      if (item?.type == null) {
        const params = {
          item: grades, //指标名称
          type: "GRADE", //指标类型
          factor: gradesFactors, //折算系数
        };
        const res = await offerPremiumAdd(params);
        message.success("保存成功");
        getOfferPremium();
      } else {
        const params = { ...item };
        params.item = grades;
        params.factor = gradesFactors;
        const res = await offerPremiumAdd(params);
        message.success("保存成功");
        getOfferPremium();
      }
    } else if (key == "score") {
      if (item?.type == null) {
        const params = {
          item: scores, //指标名称
          type: "SCORE", //指标类型
          factor: scoresFactor, //折算系数
        };
        const res = await offerPremiumAdd(params);
        message.success("保存成功");
        getOfferPremium();
      } else {
        const params = { ...item };
        params.item = scores;
        params.factor = scoresFactor;
        const res = await offerPremiumAdd(params);
        message.success("保存成功");
        getOfferPremium();
      }
    } else if (key == "risk") {
      if (item?.type == null) {
        const params = {
          item: risks, //指标名称
          type: "RISK", //指标类型
          factor: riskFactors, //折算系数
        };
        const res = await offerPremiumAdd(params);
        message.success("保存成功");
        getOfferPremium();
      } else {
      const params = { ...item };
      params.factor = riskFactors;
      params.item = risks
      const res = await offerPremiumAdd(params);
      message.success("保存成功");
      getOfferPremium();
    }
    } else if (key == "device") {
      if (item?.factor == null) {
        const params = {
          factor: deviceFactors, //指标名称
          type: "DEVICE", //指标类型
          item: "设备保费", //指标名称
          area: deviceAreas, //区域
          areas: null,
        };
        const res = await offerPremiumAdd(params);
        message.success("保存成功");
        getOfferPremium();
      } else {
        const params = { ...item };
        params.factor = deviceFactors;
        params.area = deviceAreas;
        params.areas = null;
        const res = await offerPremiumAdd(params);
        message.success("保存成功");
        getOfferPremium();
      }
    } else if (key == "tax") {
      if (item?.factor == null) {
        const params = {
          factor: taxFactors, //指标名称
          type: "TAX", //指标类型
          item: "税点",
          area: taxAreas, //区域
          areas: null,
        };
        const res = await offerPremiumAdd(params);
        message.success("保存成功");
        getOfferPremium();
      } else {
        const params = { ...item };
        params.factor = taxFactors;
        params.area = taxAreas;
        params.areas = null;
        const res = await offerPremiumAdd(params);
        message.success("保存成功");
        getOfferPremium();
      }
    } else if (key == "newenergy") {
      if (item?.item == null) {
        const params = {
          item: newenergyItem, //指标名称
          area: newenergyAreas, //区域
          areas: null,
          factor: newenergyFactors, //指标名称
          type: "NEWENERGY", //指标类型
        };
        const res = await offerPremiumAdd(params);
        message.success("保存成功");
        getOfferPremium();
      } else {
        const params = { ...item };
        params.item = newenergyItem;
        params.factor = newenergyFactors;
        params.area = newenergyAreas;
        params.areas = null;
        const res = await offerPremiumAdd(params);
        message.success("保存成功");
        getOfferPremium();
      }
    } else if (key == "unnewenergy") {
      if (item?.item == null) {
        const params = {
          item: unNewenergyItem, //指标名称
          area: unNewenergyAreas, //区域
          areas: null,
          factor: unNewenergyFactors, //指标名称
          type: "UNNEWENERGY", //指标类型
        };
        const res = await offerPremiumAdd(params);
        message.success("保存成功");
        getOfferPremium();
      } else {
        const params = { ...item };
        params.item = unNewenergyItem;
        params.factor = unNewenergyFactors;
        params.area = unNewenergyAreas;
        params.areas = null;
        const res = await offerPremiumAdd(params);
        message.success("保存成功");
        getOfferPremium();
      }
    } else if (key == "vehicletype") {
      console.info("执行vehicletype")
      const params = { ...item };
      params.factor1 = vehicletypeFactorsOne;
      params.factor2 = vehicletypeFactorsTwo;
      params.factor3 = vehicletypeFactorsThree;
      params.factor4 = vehicletypeFactorsFour;
      params.factor5 = vehicletypeFactorsFive;
      params.factor6 = vehicletypeFactorsSix;
      params.factor7 = vehicletypeFactorsSeven;
      params.factor = vehicletypeFactors;
      params.area = vehicletypeAreas;
      params.areas = null;
      const res = await offerPremiumAdd(params);
      message.success("保存成功");
      getOfferPremium();
    } else if (key == "scoreGrade") {
      const params = { ...item };
      params.factor =scoreGradeFactorsOne ;
      params.factor1 = scoreGradeFactorsTwo;
      params.factor2 = scoreGradeFactorsThree;

      params.area = "ALL";
      params.areas = null;
      const res = await offerPremiumAdd(params);
      message.success("保存成功");
      getOfferPremium();
    }
  };

  //保司评价
  const changeItem = async (e: any, item: any) => {
    setGrades(e);
  };
  //新增保司评价
  const addItemColumns = () => {
    const aaa = itemColumnsValue;
    setItemColumnsValue([ {}, ...aaa,]);
  };
  //保司评价折算配置表格列
  const itemColumns = [
    {
      title: "指标",
      dataIndex: "item",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeItem(e.target.value, item)}
        />
      ),
    },
    {
      title: "折算系数",
      dataIndex: "factor",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeFactor(e.target.value, "grade")}
        />
      ),
    },
    {
      title: "操作",
      dataIndex: "operate",
      width: 120,
      render: (value: any, item: any, index: any) => {
        return (
          <div className={styles.tableOperateColumn}>
            <Button
              type="primary"
              danger
              onClick={() => deleteDataColumns(item.id)}
            >
              删除
            </Button>
            <Button
              type="primary"
              style={{ marginLeft: 10 }}
              onClick={() => saveData(item, "grade")}
            >
              保存
            </Button>
          </div>
        );
      },
    },
  ];

  //商业分析
  const changeScore = async (e: any, item: any) => {
    setScores(e);
  };
  //新增商业分析
  const addScoreColumns = () => {
    const aaa = scoreColumnsValue;
    setScoreColumnsValue([ {}, ...aaa,]);
  };
  //商业分析配置表格列
  const scoreColumns = [
    {
      title: "商业分析",
      dataIndex: "item",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeScore(e.target.value, item)}
        />
      ),
    },
    {
      title: "折算系数",
      dataIndex: "factor",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeFactor(e.target.value, "score")}
        />
      ),
    },
    {
      title: "操作",
      dataIndex: "operate",
      width: 120,
      render: (value: any, item: any, index: any) => {
        return (
          <div className={styles.tableOperateColumn}>
            <Button
              type="primary"
              danger
              onClick={() => deleteDataColumns(item.id)}
            >
              删除
            </Button>
            <Button
              type="primary"
              style={{ marginLeft: 10 }}
              onClick={() => saveData(item, "score")}
            >
              保存
            </Button>
          </div>
        );
      },
    },
  ];

  const changeRisk = (e:any, item:any) => {
    setRisks(e)
  }

  //新增NCD系数折算配置
  const addRiskColumns = async () => {
    const params = {
      item: '', //指标名称
      type: "RISK", //指标类型
    };
    const res = await offerPremiumAdd(params);
    getOfferPremium();
  };
  //NCD系数折算配置表格列
  const riskColumns = [
    {
      title: "NCD系数",
      dataIndex: "item",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeRisk(e.target.value, item)}
        />
      ),
    },
    {
      title: "折算系数",
      dataIndex: "factor",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeFactor(e.target.value, "risk")}
        />
      ),
    },
    {
      title: "操作",
      dataIndex: "operate",
      width: 120,
      render: (value: any, item: any, index: any) => {
        return (
          <div className={styles.tableOperateColumn}>
            <Button
              type="primary"
              danger
              onClick={() => deleteDataColumns(item.id)}
            >
              删除
            </Button>
            <Button
              type="primary"
              style={{ marginLeft: 10 }}
              onClick={() => saveData(item, "risk")}
            >
              保存
            </Button>
          </div>
        );
      },
    },
  ];

  //新增设备保费指标
  const addDeviceColumns = () => {
    const aaa = deviceColumnsValue;
    setDeviceColumnsValue([{}, ...aaa, ]);
  };
  //设备保费折算配置表格列
  const deviceColumns = [
    {
      title: "保费(元)",
      dataIndex: "factor",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeFactor(e.target.value, "device")}
        />
      ),
    },
    {
      title: "区域",
      dataIndex: "areas",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Cascader
          fieldNames={{ label: "name", value: "code" }}
          placeholder="请选择区域"
          defaultValue={value ? value : ""}
          onChange={(e) => changeAreas(e, "device")}
          // multiple
          allowClear
          showArrow
          showSearch
          options={area}
          changeOnSelect
          // showCheckedStrategy={SHOW_CHILD}
        />
      ),
    },
    {
      title: "操作",
      dataIndex: "operate",
      width: 120,
      render: (value: any, item: any, index: any) => {
        return (
          <div className={styles.tableOperateColumn}>
            <Button
              type="primary"
              danger
              onClick={() => deleteDataColumns(item.id)}
            >
              删除
            </Button>
            <Button
              type="primary"
              style={{ marginLeft: 10 }}
              onClick={() => saveData(item, "device")}
            >
              保存
            </Button>
          </div>
        );
      },
    },
  ];

  //新增基础税费指标
  const addTaxColumns = (index: any) => {
    const aaa = taxColumnsValue;
    setTaxColumnsValue([ {}, ...aaa,]);
  };
  //基础税费配置表格列
  const taxColumns = [
    {
      title: "税点",
      dataIndex: "factor",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeFactor(e.target.value, "tax")}
        />
      ),
    },
    {
      title: "区域",
      dataIndex: "areas",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Cascader
          fieldNames={{ label: "name", value: "code" }}
          placeholder="请选择区域"
          defaultValue={value ? value : ""}
          onChange={(e) => changeAreas(e, "tax")}
          // multiple
          allowClear
          showArrow
          showSearch
          options={area}
          changeOnSelect
          // showCheckedStrategy={SHOW_CHILD}
        />
      ),
    },
    {
      title: "操作",
      dataIndex: "operate",
      width: 120,
      render: (value: any, item: any, index: any) => {
        return (
          <div className={styles.tableOperateColumn}>
            <Button
              type="primary"
              danger
              onClick={() => deleteDataColumns(item.id)}
            >
              删除
            </Button>
            <Button
              type="primary"
              style={{ marginLeft: 10 }}
              onClick={() => saveData(item, "tax")}
            >
              保存
            </Button>
          </div>
        );
      },
    },
  ];

  //新能源车分期支付
  const changeNewenergy = async (e: any, item: any) => {
    setNewenergyItem(e);
  };
  //编辑区域
  const changeNewenergyArea = async (e: any, item: any) => {
    //循环遍历e
    const aa = e;
    const params = { ...item };
    params.area = aa.join(",");
    params.areas = null;
    const res = await offerPremiumAdd(params);
  };
  //新增新能源车分期支付
  const addNewenergyColumns = (index: any) => {
    const aaa = newenergyColumnsValue;
    setNewenergyColumnsValue([{}, ...aaa, ]);
  };
  //新能源车配置表格列
  const newenergyColumns = [
    {
      title: "指标",
      dataIndex: "item",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeNewenergy(e.target.value, item)}
        />
      ),
    },
    {
      title: "区域",
      dataIndex: "areas",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Cascader
          fieldNames={{ label: "name", value: "code" }}
          placeholder="请选择区域"
          defaultValue={value ? value : ""}
          onChange={(e) => changeAreas(e, "newenergy")}
          // multiple
          allowClear
          showArrow
          showSearch
          options={area}
          changeOnSelect
        />
      ),
    },
    {
      title: "折算系数",
      dataIndex: "factor",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeFactor(e.target.value, "newenergy")}
        />
      ),
    },
    {
      title: "操作",
      dataIndex: "operate",
      width: 120,
      render: (value: any, item: any, index: any) => {
        return (
          <div className={styles.tableOperateColumn}>
            <Button
              type="primary"
              danger
              onClick={() => deleteDataColumns(item.id)}
            >
              删除
            </Button>
            <Button
              type="primary"
              style={{ marginLeft: 10 }}
              onClick={() => saveData(item, "newenergy")}
            >
              保存
            </Button>
          </div>
        );
      },
    },
  ];

  //非新能源车分期支付
  const changeUnnewenergy = async (e: any, item: any) => {
    setUnNewenergyItem(e);
  };
    //中富评级评分配置
  const changeScoreGrade = async (e: any, item: any) => {
    setScoreGradeItem(e);
  };
  //编辑非新能源车分期支付折算系数
  const changeUnnewenergyFactor = async (e: any, item: any) => {
    const params = { ...item };
    params.factor = e;
    const res = await offerPremiumAdd(params);
  };
  //新增非新能源车分期支付
  const addUnnewenergyColumns = (index: any) => {
    const aaa = unnewenergyColumnsValue;
    setUnnewenergyColumnsValue([{}, ...aaa, ]);
  };


  //非新能源车配置表格列
  const unnewenergyColumns = [
    {
      title: "指标",
      dataIndex: "item",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeUnnewenergy(e.target.value, item)}
        />
      ),
    },
     {
      title: "区域",
      dataIndex: "areas",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Cascader
          fieldNames={{ label: "name", value: "code" }}
          placeholder="请选择区域"
          defaultValue={value ? value : ""}
          onChange={(e) => changeAreas(e, "unnewenergy")}
          // multiple
          allowClear
          showArrow
          showSearch
          options={area}
          changeOnSelect
        />
      ),
    },
    {
      title: "系数",
      dataIndex: "factor",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeFactor(e.target.value, "unnewenergy")}
        />
      ),
    },
    {
      title: "操作",
      dataIndex: "operate",
      width: 120,
      render: (value: any, item: any, index: any) => {
        return (
          <div className={styles.tableOperateColumn}>
            <Button
              type="primary"
              danger
              onClick={() => deleteDataColumns(item.id)}
            >
              删除
            </Button>
            <Button
              type="primary"
              style={{ marginLeft: 10 }}
              onClick={() => saveData(item, "unnewenergy")}
            >
              保存
            </Button>
          </div>
        );
      },
    },
  ];
    // 新增 中富评分评级配置
  const addScoreGradeColumns = (index: any) => {
    const aaa = scoreGradeColumnsValue;
    setScoreGradeColumnsValue([{}, ...aaa, ]);
  };
  // 中富评级评分配置 配置表格列
  const scoreGradeColumns = [
    {
      title: "指标",
      dataIndex: "item",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeScoreGrade(e.target.value, item)}
        />
      ),
    },
    {
      title: "系数",
      dataIndex: "factor",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeFactor(e.target.value, "scoreGradeOne")}
        />
      ),
    },
    {
      title: "均值",
      dataIndex: "factor1",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeFactor(e.target.value, "scoreGradeTwo")}
        />
      ),
    },
        {
      title: "标准值",
      dataIndex: "factor2",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeFactor(e.target.value, "scoreGradeThree")}
        />
      ),
    },
    {
      title: "操作",
      dataIndex: "operate",
      width: 120,
      render: (value: any, item: any, index: any) => {
        return (
          <div className={styles.tableOperateColumn}>
            <Button
              type="primary"
              danger
              onClick={() => deleteDataColumns(item.id)}
            >
              删除
            </Button>
            <Button
              type="primary"
              style={{ marginLeft: 10 }}
              onClick={() => saveData(item, "scoreGrade")}
            >
              保存
            </Button>
          </div>
        );
      },
    },
  ];


  //车型配置
  const changeVehicletype = (e: any, item: any) => {
    item.map(async (item: any) => {
      // 新增
      if (item.item == null) {
        const params = {
          item: e, //指标名称
          type: "VEHICLETYPE", //指标类型
        };
        setVehicleTypeActiveKey([...vehicleTypeActiveKey, e]);
        const res = await offerPremiumAdd(params);
        // getOfferPremium();
        //编辑
      } else {
        const params = { ...item };
        params.item = e;
        setVehicleTypeActiveKey([...vehicleTypeActiveKey, e]);
        const res = await offerPremiumAdd(params);
      }
    });
  };
  //新增车型
  const addVehicletypeColumns = () => {
    const aaa = vehicletypeColumnsValue;
    //给定一个[{item:null 方便下面遍历出来数据}]
    setVehicletypeColumnsValue([...aaa, [{ item: null }]]);
    setVehicleTypeActiveKey([...vehicleTypeActiveKey, "null"]);
    setTimeout(() => {
      $(".ant-tabs-tabpane.ant-tabs-tabpane-active")[0].scrollTop = $(
        ".ant-tabs-tabpane.ant-tabs-tabpane-active"
      )[0].scrollHeight - $(".ant-tabs-tabpane.ant-tabs-tabpane-active")[0].offsetHeight;
    }, 10);
  };

  useLayoutEffect(() => {}, []);
  //新增车型区域配置
  const addVehicletypeColumnsItem = async (item: any) => {
    const params = {
      item: item[0]?.item, //指标名称
      type: "VEHICLETYPE", //指标类型
    };
    const res = await offerPremiumAdd(params);
    getOfferPremium();
  };
  //车型配置配置表格列
  const vehicletypeColumns = [
    {
      title: "区域",
      dataIndex: "areas",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Cascader
          fieldNames={{ label: "name", value: "code" }}
          placeholder="请选择区域"
          defaultValue={value ? value : ""}
          onChange={(e) => changeAreas(e, "vehicletype")}
          // multiple
          allowClear
          showArrow
          showSearch
          options={area}
          changeOnSelect
          // showCheckedStrategy={SHOW_CHILD}
        />
      ),
    },
    {
      title: "机动车（不含车损）",
      dataIndex: "factor",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeFactor(e.target.value, "vehicletype")}
        />
      ),
    },
    {
      title: "机动车（含车损）",
      dataIndex: "factor1",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeFactor(e.target.value, "vehicletypeOne")}
        />
      ),
    },
    {
      title: "特种车（不含车损）",
      dataIndex: "factor2",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeFactor(e.target.value, "vehicletypeTwo")}
        />
      ),
    },
    {
      title: "特种车（含车损）",
      dataIndex: "factor3",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeFactor(e.target.value, "vehicletypeThree")}
        />
      ),
    },
    {
      title: "新能源车（不含车损）",
      dataIndex: "factor4",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeFactor(e.target.value, "vehicletypeFour")}
        />
      ),
    },
    {
      title: "新能源车（含车损）",
      dataIndex: "factor5",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeFactor(e.target.value, "vehicletypeFive")}
        />
      ),
    },
    {
      title: "天然气车（不含车损）",
      dataIndex: "factor7",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeFactor(e.target.value, "vehicletypeSeven")}
        />
      ),
    },
    {
      title: "天然气车（含车损）",
      dataIndex: "factor6",
      width: 120,
      render: (value: any, item: any, index: any) => (
        <Input
          defaultValue={value}
          onBlur={(e) => changeFactor(e.target.value, "vehicletypeSix")}
        />
      ),
    },
    {
      title: "操作",
      dataIndex: "operate",
      width: 120,
      render: (value: any, item: any, index: any) => {
        return (
          <div className={styles.tableOperateColumn}>
            <Button
              type="primary"
              danger
              onClick={() => deleteDataColumns(item.id)}
            >
              删除
            </Button>
            <Button
              type="primary"
              style={{ marginLeft: 10 }}
              onClick={() => saveData(item, "vehicletype")}
            >
              保存
            </Button>
          </div>
        );
      },
    },
  ];

  const isBrandModelRecord = (item: any) =>
    item?.isBrandModel ||
    (item?.subItem1 !== undefined && item?.subItem1 !== null && item?.subItem1 !== "");

  const cleanBrandParams = (params: any) => {
    const next = { ...params };
    delete next.isBrandModel;
    delete next._key;
    return next;
  };

  const getBrandGroupKey = (item: any, index: any) => {
    return item?.[0]?._key || item?.[0]?.item || `brand-${index}`;
  };

  const getBrandModelRows = (item: any) => {
    return item?.filter((record: any) => isBrandModelRecord(record)) || [];
  };

  //品牌配置
  const changeBrand = async (e: any, item: any, index: any) => {
    const brandName = `${e || ""}`.trim();
    if (!brandName) {
      message.warning("请输入品牌名称");
      return;
    }

    const records = item || [];
    records.forEach((record: any) => {
      record.item = brandName;
    });
    setBrandColumnsValue([...brandColumnsValue]);

    const hasParentRecord = records.some((record: any) => !isBrandModelRecord(record));
    const requests = records
      .map((record: any) => {
        if (isBrandModelRecord(record) && !record.subItem1) {
          return null;
        }
        return offerPremiumAdd(cleanBrandParams({
          ...record,
          item: brandName,
          type: "BRAND",
        }));
      })
      .filter(Boolean);

    if (!hasParentRecord) {
      requests.unshift(offerPremiumAdd({
        item: brandName,
        type: "BRAND",
      }));
    }

    await Promise.all(requests);
    setBrandActiveKey([...brandActiveKey, brandName]);
    message.success("保存成功");
    getOfferPremium();
  };

  //新增品牌
  const addBrandColumns = () => {
    const key = `new-brand-${Date.now()}`;
    const aaa = brandColumnsValue;
    setBrandColumnsValue([...aaa, [{ item: "", _key: key }]]);
    setBrandActiveKey([...brandActiveKey, key]);
    setTimeout(() => {
      $(".ant-tabs-tabpane.ant-tabs-tabpane-active")[0].scrollTop = $(
        ".ant-tabs-tabpane.ant-tabs-tabpane-active"
      )[0].scrollHeight - $(".ant-tabs-tabpane.ant-tabs-tabpane-active")[0].offsetHeight;
    }, 10);
  };

  //新增品牌车型
  const addBrandColumnsItem = (item: any, index: any) => {
    const brandName = `${item?.[0]?.item || ""}`.trim();
    if (!brandName) {
      message.warning("请先填写品牌名称");
      return;
    }

    const key = `new-brand-model-${Date.now()}`;
    const aaa = [...brandColumnsValue];
    aaa[index] = [...item, { item: brandName, subItem1: "", isBrandModel: true, _key: key }];
    setBrandColumnsValue(aaa);

    const panelKey = getBrandGroupKey(item, index);
    if (!brandActiveKey.includes(panelKey)) {
      setBrandActiveKey([...brandActiveKey, panelKey]);
    }
  };

  const changeBrandSubItem = (e: any, item: any) => {
    item.subItem1 = e;
  };

  const changeBrandFactor = (e: any, item: any) => {
    item.factor = e;
  };

  const saveBrandData = async (item: any) => {
    const brandName = `${item?.item || ""}`.trim();
    const subItem1 = `${item?.subItem1 || ""}`.trim();
    const isModelRecord = isBrandModelRecord(item);
    if (!brandName) {
      message.warning("请先填写品牌名称");
      return;
    }
    if (isModelRecord && !subItem1) {
      message.warning("请输入车型名称");
      return;
    }

    const params = cleanBrandParams({
      ...item,
      item: brandName,
      type: "BRAND",
    });
    if (isModelRecord) {
      params.subItem1 = subItem1;
    } else {
      delete params.subItem1;
    }
    await offerPremiumAdd(params);
    message.success("保存成功");
    getOfferPremium();
  };

  const carTypeOptions = [
    ...vehicleType,
    { label: "其他", value: "其他" },
  ];

  //品牌配置表格列
  const brandColumns = [
    {
      title: "类型",
      dataIndex: "type",
      width: 80,
      render: (value: any, item: any) => (isBrandModelRecord(item) ? "车型" : "品牌"),
    },
    {
      title: "名称",
      dataIndex: "subItem1",
      width: 160,
      render: (value: any, item: any, index: any) => {
        if (isBrandModelRecord(item)) {
          return (
            <Select
              defaultValue={value}
              placeholder="请选择车型"
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
              options={carTypeOptions}
              onChange={(e) => changeBrandSubItem(e, item)}
              style={{ width: "100%" }}
            />
          );
        }
        return item.item;
      },
    },
    {
      title: "系数",
      dataIndex: "factor",
      width: 120,
      render: (value: any, item: any) => (
        <Input
          defaultValue={value}
          placeholder="请输入系数"
          onBlur={(e) => changeBrandFactor(e.target.value, item)}
        />
      ),
    },
    {
      title: "操作",
      dataIndex: "operate",
      width: 120,
      render: (value: any, item: any, index: any) => {
        return (
          <div className={styles.tableOperateColumn}>
            <Button
              type="primary"
              danger
              onClick={() => deleteDataColumns(item.id)}
            >
              删除
            </Button>
            <Button
              type="primary"
              style={{ marginLeft: 10 }}
              onClick={() => saveBrandData(item)}
            >
              保存
            </Button>
          </div>
        );
      },
    },
  ];

  return (
    <Card bordered={false} className={styles.reportBox}>
      <Form
        layout="vertical"
        autoComplete="off"
        form={form}
        scrollToFirstError
        initialValues={{ managementCode: [{}], adviseColumnsCode: [{}] }}
      >
        <Collapse
          activeKey={activeKey}
          onChange={(keys: any) => setActiveKey(keys)}
        >
          {/* <LoadingWrapper spinning={loading} autoHeight> */}
          <Panel header="通用配置" key="column">
            <LoadingWrapper spinning={loading} autoHeight>
              <Collapse>
                <Panel key="item" header="保司评价折算配置">
                  <Form.Item label="保司评价折算配置" name="item">
                    <Button type="primary" onClick={addItemColumns}>
                      新增
                    </Button>
                    <Table
                      columns={itemColumns}
                      dataSource={itemColumnsValue}
                      rowKey="item"
                    />
                  </Form.Item>
                </Panel>
                <Panel key="score" header="商业分析折算配置">
                  <Form.Item label="商业分析折算配置" name="score">
                    <Button type="primary" onClick={addScoreColumns}>
                      新增
                    </Button>
                    <Table
                      columns={scoreColumns}
                      dataSource={scoreColumnsValue}
                      rowKey="id"
                    />
                  </Form.Item>
                </Panel>
                <Panel key="risk" header="NCD系数折算配置">
                  <Form.Item label="NCD系数折算配置" name="risk">
                    <Button type="primary" onClick={addRiskColumns}>
                      新增
                    </Button>
                    <Table
                      columns={riskColumns}
                      dataSource={riskColumnsValue}
                      rowKey="id"
                    />
                  </Form.Item>
                </Panel>
                <Panel key="device" header="设备保费配置">
                  <Form.Item label="设备保费配置" name="device">
                    <Button type="primary" onClick={addDeviceColumns}>
                      新增
                    </Button>
                    <Table
                      columns={deviceColumns}
                      dataSource={deviceColumnsValue}
                      rowKey="id"
                    />
                  </Form.Item>
                </Panel>
                <Panel key="tax" header="基础税费配置">
                  <Form.Item label="基础税费配置" name="tax">
                    <Button type="primary" onClick={addTaxColumns}>
                      新增
                    </Button>
                    <Table
                      columns={taxColumns}
                      dataSource={taxColumnsValue}
                      rowKey="id"
                    />
                  </Form.Item>
                </Panel>
                <Panel key="newenergy" header="新能源车分期支付配置">
                  <Form.Item label="新能源车分期支付配置" name="newenergy">
                    <Button type="primary" onClick={addNewenergyColumns}>
                      新增
                    </Button>
                    <Table
                      columns={newenergyColumns}
                      dataSource={newenergyColumnsValue}
                      rowKey="id"
                    />
                  </Form.Item>
                </Panel>
                <Panel key="unnewenergy" header="非新能源车分期支付配置">
                  <Form.Item label="非新能源车分期支付配置" name="unnewenergy">
                    <Button type="primary" onClick={addUnnewenergyColumns}>
                      新增
                    </Button>
                    <Table
                      columns={unnewenergyColumns}
                      dataSource={unnewenergyColumnsValue}
                      rowKey="id"
                    />
                  </Form.Item>
                </Panel>
                <Panel key="scoreGrade" header="中富评分评级配置">
                  <Form.Item label="中富评分评级配置" name="scoreGrade">
                    <Button type="primary" onClick={addScoreGradeColumns}>
                      新增
                    </Button>
                    <Table
                      columns={scoreGradeColumns}
                      dataSource={scoreGradeColumnsValue}
                      rowKey="id"
                    />
                  </Form.Item>
                </Panel>
              </Collapse>
            </LoadingWrapper>
          </Panel>
          <Panel header="车型配置" key={"vehicletype"}>
            <LoadingWrapper spinning={loading} autoHeight>
              <Form.Item label="" name="vehicletype">
                <Button type="primary" onClick={addVehicletypeColumns}>
                  新增
                </Button>
                <Collapse
                  activeKey={vehicleTypeActiveKey}
                  onChange={(keys: any) => setVehicleTypeActiveKey(keys)}
                >
                  {vehicletypeColumnsValue?.map((item: any, index: any) => (
                    <Panel key={item[0]?.item} header={item[0]?.item}>
                      <span style={{ fontWeight: 800 }}>指标:</span>
                      <Input
                        style={{ width: 300, margin: "20px" }}
                        defaultValue={item[0]?.item}
                        onBlur={(e) => changeVehicletype(e.target.value, item)}
                      />
                      <Button
                        type="primary"
                        shape="circle"
                        icon={<PlusOutlined />}
                        onClick={() => addVehicletypeColumnsItem(item)}
                      ></Button>
                      <Table
                        columns={vehicletypeColumns}
                        dataSource={item}
                        pagination={false}
                        rowKey="id"
                      />
                    </Panel>
                  ))}
                </Collapse>
                {/* <Table  columns={vehicletypeColumns} dataSource={vehicletypeColumnsValue}  pagination={false} /> */}
              </Form.Item>
            </LoadingWrapper>
          </Panel>
          <Panel header="品牌配置" key={"brand"}>
            <LoadingWrapper spinning={loading} autoHeight>
              <Form.Item label="" name="brand">
                <Button type="primary" onClick={addBrandColumns}>
                  新增
                </Button>
                <Collapse
                  activeKey={brandActiveKey}
                  onChange={(keys: any) => setBrandActiveKey(keys)}
                >
                  {brandColumnsValue?.map((item: any, index: any) => (
                    <Panel key={getBrandGroupKey(item, index)} header={item[0]?.item || "新增品牌"}>
                      <span style={{ fontWeight: 800 }}>品牌:</span>
                      <Input
                        style={{ width: 300, margin: "20px" }}
                        defaultValue={item[0]?.item}
                        placeholder="请输入品牌名称"
                        onBlur={(e) => changeBrand(e.target.value, item, index)}
                      />
                      <Button
                        type="primary"
                        shape="circle"
                        icon={<PlusOutlined />}
                        onClick={() => addBrandColumnsItem(item, index)}
                      ></Button>
                      <Table
                        columns={brandColumns}
                        dataSource={getBrandModelRows(item)}
                        pagination={false}
                        rowKey={(record: any, rowIndex: any) =>
                          record.id ||
                          record._key ||
                          `${record.item || "brand"}-${record.subItem1 || "parent"}-${rowIndex}`
                        }
                      />
                    </Panel>
                  ))}
                </Collapse>
              </Form.Item>
            </LoadingWrapper>
          </Panel>
          
          {/* </LoadingWrapper> */}
        </Collapse>
      </Form>
    </Card>
  );
};

export default offerManage;
